// auth.js
export const LOGOUT = "LOGOUT";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const UPDATE_USER = "UPDATE_USER";

// lang.js
export const SET_LOCALE = "SET_LOCALE";

// assuntos.js
export const FETCH_ASSUNTOS_SUCCESS = "FETCH_ASSUNTOS_SUCCESS";
export const FETCH_ASSUNTOS_FAILURE = "FETCH_ASSUNTOS_FAILURE";

// cursos.js
export const FETCH_CURSOS_SUCCESS = "FETCH_CURSOS_SUCCESS";
export const FETCH_CURSOS_FAILURE = "FETCH_CURSOS_FAILURE";

// ufs.js
export const FETCH_UFS_SUCCESS = "FETCH_UFS_SUCCESS";
export const FETCH_UFS_FAILURE = "FETCH_UFS_FAILURE";



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js